import {voteValue} from "../utils/votes";

export const loadCollection = (map, items, keyOrFunc) => {
    let keyOf;
    if (typeof keyOrFunc === 'function') {
        keyOf = keyOrFunc;
    } else if (typeof keyOrFunc === 'string') {
        keyOf = (item) => item[keyOrFunc];
    }
    return map.withMutations((mutMap) => {
        for (const item of items) {
            mutMap.set(keyOf(item), item);
        }
    });
};

export const itemVoteChanged = ({score, vote_state, ...item}, voteState) => {
    score = score - voteValue(vote_state) + voteValue(voteState);
    vote_state = voteState;
    return {...item, score, vote_state};
};


